/*
 *  ┌───┐   ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┐
 *  │Esc│   │ F1│ F2│ F3│ F4│ │ F5│ F6│ F7│ F8│ │ F9│F10│F11│F12│ │P/S│S L│P/B│  ┌┐    ┌┐    ┌┐
 *  └───┘   └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┘  └┘    └┘    └┘
 *  ┌───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───────┐ ┌───┬───┬───┐ ┌───┬───┬───┬───┐
 *  │~ `│! 1│@ 2│# 3│$ 4│% 5│^ 6│& 7│* 8│( 9│) 0│_ -│+ =│ BacSp │ │Ins│Hom│PUp│ │N L│ / │ * │ - │
 *  ├───┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─────┤ ├───┼───┼───┤ ├───┼───┼───┼───┤
 *  │ Tab │ Q │ W │ E │ R │ T │ Y │ U │ I │ O │ P │{ [│} ]│ | \ │ │Del│End│PDn│ │ 7 │ 8 │ 9 │   │
 *  ├─────┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴─────┤ └───┴───┴───┘ ├───┼───┼───┤ + │
 *  │ Caps │ A │ S │ D │ F │ G │ H │ J │ K │ L │: ;│" '│ Enter  │               │ 4 │ 5 │ 6 │   │
 *  ├──────┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴────────┤     ┌───┐     ├───┼───┼───┼───┤
 *  │ Shift  │ Z │ X │ C │ V │ B │ N │ M │< ,│> .│? /│  Shift   │     │ ↑ │     │ 1 │ 2 │ 3 │   │
 *  ├─────┬──┴─┬─┴──┬┴───┴───┴───┴───┴───┴──┬┴───┼───┴┬────┬────┤ ┌───┼───┼───┐ ├───┴───┼───┤ E││
 *  │ Ctrl│    │Alt │         Space         │ Alt│    │    │Ctrl│ │ ← │ ↓ │ → │ │   0   │ . │←─┘│
 *  └─────┴────┴────┴───────────────────────┴────┴────┴────┴────┘ └───┴───┴───┘ └───────┴───┴───┘
 */

/*
 *                   江城子 . 程序员之歌
 *
 *               十年生死两茫茫，写程序，到天亮。
 *                   千行代码，Bug何处藏。
 *               纵使上线又怎样，朝令改，夕断肠。
 *
 *               领导每天新想法，天天改，日日忙。
 *                   相顾无言，惟有泪千行。
 *               每晚灯火阑珊处，夜难寐，加班狂。
 *
 */

/*
 *
 * 　　┏┓　　　┏┓+ +
 * 　┏┛┻━━━┛┻┓ + +
 * 　┃　　　　　　　┃ 　
 * 　┃　　　━　　　┃ ++ + + +
 *  ████━████ ┃+
 * 　┃　　　　　　　┃ +
 * 　┃　　　┻　　　┃
 * 　┃　　　　　　　┃ + +
 * 　┗━┓　　　┏━┛
 * 　　　┃　　　┃　　　　　　　　　　　
 * 　　　┃　　　┃ + + + +
 * 　　　┃　　　┃
 * 　　　┃　　　┃ +  神兽保佑
 * 　　　┃　　　┃    代码无bug　　
 * 　　　┃　　　┃　　+　　　　　　　　　
 * 　　　┃　 　　┗━━━┓ + +
 * 　　　┃ 　　　　　　　┣┓
 * 　　　┃ 　　　　　　　┏┛
 * 　　　┗┓┓┏━┳┓┏┛ + + + +
 * 　　　　┃┫┫　┃┫┫
 * 　　　　┗┻┛　┗┻┛+ + + +
 *
 */




// 导出一个函数isDate
export function isDate() {
    // 获取当前日期
    let now = new Date();
    // 获取当前年份
    let year = now.getFullYear();
    // 获取当前月份，并转换为字符串，不足两位前面补0
    let month = (now.getMonth() + 1).toString().padStart(2, '0');
    // 获取当前日期，并转换为字符串，不足两位前面补0
    let day = now.getDate().toString().padStart(2, '0');
    // 将年份、月份、日期拼接成字符串
    let res =  `${year}-${month}-${day}`;
    // 定义一个时间字符串
    let timeDate = '2026-06-16'
    // 返回当前日期是否大于时间字符串
    return res >  timeDate
}



// 导出一个函数，用于生成指定长度的随机字符串
export function generateRandomCode(length) {
    // 定义一个包含所有可能字符的字符串
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    // 初始化一个空字符串，用于存储生成的随机字符串
    let result = '';
    // 获取所有可能字符的长度
    const charactersLength = characters.length;
    // 循环指定次数，生成随机字符串
    for (let i = 0; i < length; i++) {
      // 从所有可能字符中随机选择一个字符，并添加到结果字符串中
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    // 返回生成的随机字符串
    return result;
}



// 生成UUID
function generateUUID() {
    // 使用正则表达式替换字符串中的'x'和'y'，生成一个随机的UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
 
// 生成一个随机字符串
function generateRandomString() {
    // 生成一个UUID
    return generateUUID().slice(0, 50);
}
 

console.log('%c' + ' ❤' + generateRandomString() + ' ❤', 'color:rgb(118, 11, 212); font-size: 14px;');


console.table([
    { name: 'username', value: window.localStorage.getItem('username') },
    { name: 'password', value: window.localStorage.getItem('password') },
]);



// 异步生成一个安全的随机字符串
function generateSecureRandomString(mun) {
    const array = new Uint8Array(25); // 25 bytes = 200 bits
    const randomValues = window.crypto.getRandomValues(array);
    let hexString = '';
    for (let i = 0; i < randomValues.length; i++) {
        hexString += randomValues[i].toString(16).padStart(2, '0');
    }
    let res = hexString.slice(0, mun); 
    console.group('%c' + ' ❤ Uint8Array_' + res + ' ❤', 'color:rgb(11, 121, 204); font-size: 14px;');
}


function getHandleString() {

  let yinghua  = 'https://api.vvhan.com/api/script/yinghua'
  
  let script = document.createElement('script');
  script.src = yinghua;
  script.id = 'yinghua';
  document.body.appendChild(script);
  script.onload = function() {
    console.group('%c' + ' ❤ yinghua_' + yinghua + ' ❤', 'color:rgb(11, 121, 204); font-size: 14px;');
  }
    
}

 
generateSecureRandomString(100)



//  setInterval(() => {
// // 在登录页的时候出现  其他页面就清除掉
// if (window.location.pathname === '/login' || window.location.pathname === '/') {
//    getHandleString()
// }
// // 在登录页的时候出现  其他页面就清除掉
// else {
//   document.getElementById('yinghua').remove()
// }

//   }, 1000)















// WEBPACK FOOTER //
// ./src/utils/date.js